module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI0M2M3NGE0OWZhYTQ5NGRmZGU4MDM1MGZiZjliNTFmNS5zdmciOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/icons/turn-arrow.svg
 ** module id = 208
 ** module chunks = 0
 **/